var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copy-right text-center pb-2 pt-2",staticStyle:{"position":"relative","bottom":"2px","right":"0","left":"0"}},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" Grid Business. All Rights Reserved. ")])}
var staticRenderFns = []

export { render, staticRenderFns }